import { BreadcrumbLink } from "@/reports/teacher/common/PageHeaderContainer/components/InsightsBreadcrumb/InsightsBreadcrumb";

const useBreadcrumbLinks = (
  breadcrumbOptions: BreadcrumbLink[],
  subsection: BreadcrumbLink[] | [] = [],
) => {
  const links = [
    {
      contents: "Reports",
      disclosureLinks: breadcrumbOptions,
    },
    ...(Array.isArray(subsection) ? subsection : [subsection]),
  ];

  return links;
};

export default useBreadcrumbLinks;
